import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "btnCont"
};
const _hoisted_2 = {
  class: "btnCont"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_calendar = _resolveComponent("van-calendar");
  const _component_van_cascader = _resolveComponent("van-cascader");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_form = _resolveComponent("van-form");
  return _openBlock(), _createBlock(_component_van_form, {
    onSubmit: $setup.onSubmit,
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        readonly: "",
        required: "",
        colon: "",
        modelValue: $data.CustomerName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.CustomerName = $event),
        name: "CustomerName",
        label: "客戶名稱",
        placeholder: "客戶名稱"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        readonly: "",
        required: "",
        colon: "",
        modelValue: $data.CustomerCode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.CustomerCode = $event),
        name: "CustomerCode",
        label: "客戶代碼",
        placeholder: "客戶代碼"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      inset: "",
      style: {
        "margin-top": "10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        required: "",
        colon: "",
        modelValue: $setup.Linkman,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.Linkman = $event),
        name: "Linkman",
        label: "聯繫人",
        placeholder: "請輸入"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        required: "",
        colon: "",
        modelValue: $setup.ContactNumber,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.ContactNumber = $event),
        name: "ContactNumber",
        label: "聯繫方式",
        placeholder: "聯繫方式"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        title: "Model | Serial No# | Cust SN#",
        name: "SN",
        modelValue: $setup.SN,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.SN = $event),
        "is-link": "",
        readonly: "",
        required: "",
        colon: "",
        label: "保養設備",
        placeholder: "選擇",
        onClick: _cache[5] || (_cache[5] = $event => $setup.showSN = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $setup.showSN,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => $setup.showSN = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "Model | Serial No# | Cust SN#",
          columns: $setup.SNList,
          onCancel: _cache[6] || (_cache[6] = $event => $setup.showSN = false),
          onConfirm: $setup.onConfirmSN,
          "columns-field-names": $setup.SNNames,
          "confirm-button-text": "確認"
        }, null, 8, ["columns", "onConfirm", "columns-field-names"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        readonly: "",
        required: "",
        colon: "",
        modelValue: $setup.Model,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.Model = $event),
        name: "Model",
        label: "設備型號"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $setup.ExpectedServiceTime,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.ExpectedServiceTime = $event),
        "is-link": "",
        readonly: "",
        required: "",
        colon: "",
        name: "ExpectedServiceTime",
        label: "預約時間",
        placeholder: "選擇",
        onClick: _cache[10] || (_cache[10] = $event => $setup.ShowDate = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $setup.ShowDate,
        "onUpdate:show": _cache[12] || (_cache[12] = $event => $setup.ShowDate = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_calendar, {
          show: $setup.ShowDate,
          "onUpdate:show": _cache[11] || (_cache[11] = $event => $setup.ShowDate = $event),
          formatter: $setup.formatter,
          "min-date": $setup.minDate,
          onConfirm: $setup.onConfirmDate,
          color: "#Fdd100",
          "show-confirm": false,
          title: "日期選擇"
        }, null, 8, ["show", "formatter", "min-date", "onConfirm"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        modelValue: $setup.fieldValue,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.fieldValue = $event),
        "is-link": "",
        readonly: "",
        required: "",
        colon: "",
        label: "地址選擇",
        placeholder: "選擇",
        name: "CountyValue",
        onClick: _cache[14] || (_cache[14] = $event => $setup.showCounty = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $setup.showCounty,
        "onUpdate:show": _cache[17] || (_cache[17] = $event => $setup.showCounty = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cascader, {
          modelValue: $setup.CountyValue,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.CountyValue = $event),
          title: "請選擇所在地區",
          placeholder: "請選擇",
          options: $setup.options,
          onClose: _cache[16] || (_cache[16] = $event => $setup.showCounty = false),
          onFinish: $setup.onFinish,
          onChange: $options.onChange,
          "active-color": "#Fdd100"
        }, null, 8, ["modelValue", "options", "onFinish", "onChange"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        required: "",
        colon: "",
        modelValue: $setup.Address,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.Address = $event),
        name: "Address",
        label: "詳細地址",
        placeholder: "請輸入"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        colon: "",
        name: "Remark",
        modelValue: $setup.Remark,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.Remark = $event),
        rows: "2",
        autosize: "",
        label: "特殊備註",
        type: "textarea",
        maxlength: "100",
        placeholder: "請輸入備註",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_row, {
      justify: "center",
      gutter: "20",
      style: {
        "margin": "16px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "12"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
          block: "",
          type: "default",
          onClick: _cache[20] || (_cache[20] = $event => this.$router.go(-1))
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "12"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
          block: "",
          type: "primary",
          onClick: _cache[21] || (_cache[21] = $event => $options.checkend()),
          color: "#Fdd100",
          style: {
            "color": "black"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 提交 ")]),
          _: 1
        })])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["onSubmit"]);
}